import _ from "lodash";

export const buildListStylesheet = (builder, device, cta, element, variant) => {
    let options = { ...element.options };

    let listIsHorizontal = options["list-layout"] == "horizontal";

    let listWidth;
    if (options["list-width"] == "cf-list-automatic") {
      if (listIsHorizontal) {
        listWidth = "fit-content";
      }
    } else if (options["list-width"] == "cf-list-full") {
      listWidth = "100%";
    } else if (
      options["list-width"] == "custom" &&
      element.options["list-width-value"]
    ) {
      listWidth = `${element.options["list-width-value"]}px`;
    } else {
      listWidth = "40%";
    }

    let borderRadius = "";
    if (options["list-border-radius"] == "cf-not-rounded") {
      borderRadius = "0px";
    }
    if (options["list-border-radius"] == "cf-slightly-rounded") {
      borderRadius = "4px";
    }
    if (options["list-border-radius"] == "cf-fully-rounded") {
      borderRadius = "100px";
    }
    if (options["list-border-radius"] == "custom") {
      borderRadius = "";
      ["top-left", "top-right", "bottom-right", "bottom-left"].forEach(
        (side) => {
          borderRadius += `${
            _.isNil(options["list-border-radius-" + side]) == false
              ? options["list-border-radius-" + side]
              : "4"
          }px `;
        }
      );
    }

    let boxShadow;

    if (options["list-container-shadow"] == "None") {
      boxShadow = "none";
    }

    if (options["list-container-shadow"] == "soft") {
      boxShadow = "0 5px 15px 0 rgb(179 179 179 / 78%)";
    }

    if (options["list-container-shadow"] == "hard") {
      boxShadow = "-5px 5px 0 0 rgb(0 0 0 / 10%)";
    }

    if (options["list-container-shadow"] == "custom") {
      boxShadow = "";
      boxShadow +=
        (element.options["list-container-shadow-horizontal-distance"]
          ? `${element.options["list-container-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["list-container-shadow-vertical-distance"]
          ? `${element.options["list-container-shadow-vertical-distance"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["list-container-shadow-blur-radius"]
          ? `${element.options["list-container-shadow-blur-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["list-container-shadow-spread-radius"]
          ? `${element.options["list-container-shadow-spread-radius"]}px`
          : "0px") + " ";

      boxShadow +=
        (element.options["list-container-shadow-color"]
          ? element.options["list-container-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
      boxShadow +=
        element.options["list-container-shadow-inset"] == "true" ? "inset" : "";
    }

    let listBackgroundColor;
    if (options["list-background"]) {
      listBackgroundColor = options["list-background"];
    }

    let outerTextAlign = "center";
    if (options["cf-alignment"]) {
      if (options["cf-alignment"].indexOf("left") > -1) {
        outerTextAlign = "left";
      } else if (options["cf-alignment"].indexOf("right") > -1) {
        outerTextAlign = "right";
      }
    }

    const horizontalFlexRow =
      "display: flex !important; flex-direction: row !important; flex-wrap: wrap !important; gap: 20px !important;";

    const horizontalMarginFor = (alignment) =>
      alignment == "left"
        ? "margin-left: 0 !important; margin-right: auto !important;"
        : alignment == "right"
        ? "margin-left: auto !important; margin-right: 0 !important;"
        : "margin-left: auto !important; margin-right: auto !important;";

    // prettier-ignore
    const desktopStyles =
      `#cta_${cta.id} .cf-element[data-element-id='${element.id}'] {
        margin-left: ${_.isNil(options['margin-left']) == false ? options['margin-left'] + 'px' : '0px'} !important;
        margin-right: ${_.isNil(options['margin-right']) == false ? options['margin-right'] + 'px' : '0px'} !important;
        margin-top: ${_.isNil(options['margin-top']) == false ? options['margin-top'] + 'px' : '0px'} !important;
        margin-bottom: ${_.isNil(options['margin-bottom']) == false ? options['margin-bottom'] + 'px' : '0px'} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element {
        text-align: ${outerTextAlign} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element ul {
        margin: initial;
        padding-left: ${_.isNil(options['padding-left']) == false ? options['padding-left'] + 'px' : '0px'} !important;
        padding-right: ${_.isNil(options['padding-right']) == false ? options['padding-right'] + 'px' : '0px'} !important;
        padding-top: ${_.isNil(options['padding-top']) == false ? options['padding-top'] + 'px' : '0px'} !important;
        padding-bottom: ${_.isNil(options['padding-bottom']) == false ? options['padding-bottom'] + 'px' : '0px'} !important;
        ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
        ${options["list-border-style"] ? 'border-style: ' + options["list-border-style"] + ' !important;' : ''}
        ${options["list-border-style"] !== "" && _.isNil(options["list-border-width"]) == false ? 'border-width: ' + options["list-border-width"] + 'px !important;' : ''}
        ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-left"]) == false ? 'border-left-width: ' + options["list-border-width-left"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-left-width: ' + options["list-border-width"] + 'px !important;' : ''}
        ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-right"]) == false ? 'border-right-width: ' + options["list-border-width-right"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-right-width: ' + options["list-border-width"] + 'px !important;' : ''}
        ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-top"]) == false ? 'border-top-width: ' + options["list-border-width-top"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-top-width: ' + options["list-border-width"] + 'px !important;' : ''}
        ${options["list-border-style"] !== "" && _.isNil(options["list-border-width-bottom"]) == false ? 'border-bottom-width: ' + options["list-border-width-bottom"] + 'px !important;' : _.isNil(options["list-border-width"]) == false ? 'border-bottom-width: ' + options["list-border-width"] + 'px !important;' : ''}
        ${options["list-border-style"] !== "" && options["list-border-color"] ? 'border-color: ' + options["list-border-color"] + ' !important;' : variant.options["list-border-color"] ? 'border-color: ' + variant.options["list-border-color"] + ' !important;' : ''}
        ${borderRadius ? 'border-radius: ' + borderRadius + ' !important;' : ''}
        ${boxShadow ? 'box-shadow: ' + boxShadow + ' !important;' : ''}
        ${listBackgroundColor ? `background: ${listBackgroundColor} !important;` : ''}
        list-style: none !important;
        ${listIsHorizontal ? horizontalFlexRow : 'display: inline-block !important;'}
        ${listIsHorizontal ? horizontalMarginFor(outerTextAlign) : ''}
        ${listWidth ? `width: ${listWidth} !important;` : ''}
        max-width: 100% !important;
        text-align: center !important;
        box-sizing: border-box;
      }

      ${listIsHorizontal ? `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element ul .cf-items-divider {
        display: none !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element ul > .cf-list-element-item {
        flex: 1 1 0% !important;
        min-width: 0 !important;
      }` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element .cf-items-divider:not(:last-child) {
        ${options["list-items-divider-style"] ? `border-style: ${options["list-items-divider-style"]};` : ''}
        ${options["list-items-divider-style"] !== "" && _.isNil(options["list-items-divider-border-width"]) == false ? `border-bottom-width: ${options["list-items-divider-border-width"]}px;`: ''}
        ${options["list-items-divider-style"] !== "" && options["list-items-divider-color"] ? `border-color: ${options["list-items-divider-color"]} !important;` : options["list-border-color"] ? `border-color: ${options["list-border-color"]};` : ''}
        ${["solid", "dashed", "dotted"].includes(options["list-items-divider-style"]) ? "margin-top: 15px; margin-bottom: 15px;" : ""}
        border-top-width: 0px;
        margin-right: auto;
        margin-left: auto;
        width: 90%;
      }
      `;

    let listLayoutMobile = options["list-layout-mobile"];
    let listIsHorizontalMobile = listLayoutMobile
      ? listLayoutMobile == "horizontal"
      : listIsHorizontal;

    let listWidthMobile;
    if (options["list-width-mobile"] == "cf-list-full") {
      listWidthMobile = "100% !important";
    } else if (
      options["list-width-mobile"] == "custom" &&
      (element.options["list-width-value-mobile"] ||
        element.options["list-width-value"])
    ) {
      listWidthMobile = `${
        element.options["list-width-value-mobile"] ||
        element.options["list-width-value"]
      }px !important`;
    } else if (listIsHorizontalMobile) {
      listWidthMobile = "fit-content !important";
    } else {
      listWidthMobile = "unset !important";
    }

    let listBackgroundColorMobile;
    if (options["list-background-mobile"]) {
      listBackgroundColorMobile = options["list-background-mobile"];
    }

    let outerTextAlignMobile;
    if (options["cf-alignment-mobile"]) {
      if (options["cf-alignment-mobile"].indexOf("left") > -1) {
        outerTextAlignMobile = "left";
      } else if (options["cf-alignment-mobile"].indexOf("center") > -1) {
        outerTextAlignMobile = "center";
      } else if (options["cf-alignment-mobile"].indexOf("right") > -1) {
        outerTextAlignMobile = "right";
      }
    }

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */
      #cta_${cta.id} .cf-element[data-element-id='${element.id}'] {
        ${_.isNil(options['margin-mobile-left']) == false ? 'margin-left: ' + options['margin-mobile-left'] + 'px !important;' : ''}
        ${_.isNil(options['margin-mobile-right']) == false ? 'margin-right: ' + options['margin-mobile-right'] + 'px !important;' : ''}
        ${_.isNil(options['margin-mobile-top']) == false ? 'margin-top: ' + options['margin-mobile-top'] + 'px !important;' : ''}
        ${_.isNil(options['margin-mobile-bottom']) == false ? 'margin-bottom: ' + options['margin-mobile-bottom'] + 'px !important;' : ''}
      }

      ${outerTextAlignMobile ? `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element {
        text-align: ${outerTextAlignMobile} !important;
      }` : ''}

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element ul {
        ${_.isNil(options['padding-mobile-left']) == false ? 'padding-left: ' + options['padding-mobile-left'] + 'px !important;' : ''}
        ${_.isNil(options['padding-mobile-right']) == false ? 'padding-right: ' + options['padding-mobile-right'] + 'px !important;' : ''}
        ${_.isNil(options['padding-mobile-top']) == false ? 'padding-top: ' + options['padding-mobile-top'] + 'px !important;' : ''}
        ${_.isNil(options['padding-mobile-bottom']) == false ? 'padding-bottom: ' + options['padding-mobile-bottom'] + 'px !important;' : ''}

        ${listWidthMobile ? `width: ${listWidthMobile};` : ''}
        ${listBackgroundColorMobile ? `background: ${listBackgroundColorMobile};` : ''}
        ${listIsHorizontalMobile ? horizontalFlexRow : 'display: inline-block !important;'}
        ${listIsHorizontalMobile ? horizontalMarginFor(outerTextAlignMobile || outerTextAlign) : ''}
      }

      ${listIsHorizontalMobile ? `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element ul .cf-items-divider {
        display: none !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element ul > .cf-list-element-item {
        flex: 1 1 0% !important;
        min-width: 0 !important;
      }` : ''}
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};

export const buildContentListItemStylesheet = (
  builder,
  device,
  cta,
  list_item,
  element,
  variant,
  visualType
) => {
    let options = { ...element.options };

    let contentFontFamily;
    if (
      options["content-font-family"] &&
      options["content-font-family"] !== "theme"
    ) {
      contentFontFamily = options["content-font-family"];
    }

    let contentFontWeight;
    if (
      options["content-font-weight"] &&
      options["content-font-weight"] !== "theme"
    ) {
      contentFontWeight = options["content-font-weight"];
    }

    let contentFontSize;
    if (options["content-font-size"]) {
      contentFontSize = options["content-font-size"];
    }

    let contentFontColor;
    if (
      options["content-font-color"] &&
      options["content-font-color"] !== "theme"
    ) {
      contentFontColor = options["content-font-color"];
    }

    let contentTextShadow;
    if (options["content-box-shadow"] == "none") {
      contentTextShadow = "none";
    }
    if (options["content-box-shadow"] == "soft") {
      contentTextShadow = "0 3px 5px rgb(179 179 179 / 78%)";
    }
    if (options["content-box-shadow"] == "hard") {
      contentTextShadow = "-3px 3px 0 rgb(0 0 0 / 10%)";
    }
    if (options["content-box-shadow"] == "custom") {
      contentTextShadow = "";
      contentTextShadow +=
        (element.options["content-box-shadow-horizontal-distance"]
          ? `${element.options["content-box-shadow-horizontal-distance"]}px`
          : "0px") + " ";

      contentTextShadow +=
        (element.options["content-box-shadow-vertical-distance"]
          ? `${element.options["content-box-shadow-vertical-distance"]}px`
          : "0px") + " ";

      contentTextShadow +=
        (element.options["content-box-shadow-blur-radius"]
          ? `${element.options["content-box-shadow-blur-radius"]}px`
          : "0px") + " ";

      contentTextShadow +=
        (element.options["content-box-shadow-color"]
          ? element.options["content-box-shadow-color"]
          : "rgba(0,0,0, 0.35)") + " ";
    }

    let contentAlignment;
    if (element.options["content-alignment"]) {
      contentAlignment = element.options["content-alignment"];
    }

    let visualTypeImageWidth;
    if (element.options["visual-type-image-width"]) {
      visualTypeImageWidth = element.options["visual-type-image-width"];
    } else if (variant.options["list-visual-type-image-width"]) {
      visualTypeImageWidth = variant.options["list-visual-type-image-width"];
    } else if (contentFontSize) {
      visualTypeImageWidth = contentFontSize * 2.5;
    } else {
      visualTypeImageWidth = "134";
    }

    let visualTypeFontSize;
    if (options["visual-type-font-size"]) {
      visualTypeFontSize = options["visual-type-font-size"];
    }

    let visualTypeFontColor;
    if (options["visual-type-font-color"]) {
      visualTypeFontColor = options["visual-type-font-color"];
    }

    let visualTypeLetterColor;
    if (visualTypeFontColor) {
      visualTypeLetterColor = visualTypeFontColor;
    } else if (variant.options["list-visual-type-font-color"]) {
      visualTypeLetterColor = variant.options["list-visual-type-font-color"];
    } else {
      visualTypeLetterColor = "#000";
    }

    let contentLineHeight;
    if (options["content-font-line-height"]) {
      contentLineHeight = options["content-font-line-height"];
    } else if (variant.options["list-content-font-line-height"]) {
      contentLineHeight = variant.options["list-content-font-line-height"];
    }

    let elementDividerPresentWithoutLineHeight =
      options["list-items-divider-style"] !== undefined &&
      options["list-items-divider-style"] !== "none" &&
      !options["content-font-line-height"];

    let variantDividerPresentWithoutLineHeight =
      variant.options["list-items-divider-style"] !== undefined &&
      variant.options["list-items-divider-style"] !== "none" &&
      !variant.options["list-content-font-line-height"];

    let visualTypeWidth = "";
    let visualFontSize =
      visualTypeFontSize || variant.options["list-visual-type-font-size"] || 16;
    visualTypeWidth = `${parseInt(visualFontSize) * 2.8}`;

    let listVisualTypeSpacing =
      options["list-visual-type-spacing"] ||
      variant.options["list-visual-type-spacing"] ||
      undefined;

    const visualTypeAlignmentValue =
      options["visual-type-alignment"] ||
      variant.options["list-visual-type-alignment"];

    const visualTypeAlignment = {
      top: "flex-start",
      center: "center",
      bottom: "flex-end",
    }[visualTypeAlignmentValue];

    const defaultVisualTypeAlignment =
      visualType === "image" || visualType === "letter"
        ? "center"
        : "flex-start";

    // prettier-ignore
    const desktopStyles =
      `#cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} {
        display: flex;
        align-items: ${visualTypeAlignment || defaultVisualTypeAlignment} !important;
        ${contentLineHeight ? `line-height: ${contentLineHeight}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type {
        ${visualTypeFontSize ? `font-size: ${visualTypeFontSize}px !important;` : ''}
        ${visualTypeFontColor ? `color: ${visualTypeFontColor} !important;` : ''}
        ${listVisualTypeSpacing ? `margin-right: ${listVisualTypeSpacing}px !important;` : `width: ${visualTypeWidth}px !important;` }
        flex-shrink: 0 !important;
        text-align: center !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type .svg-inline--fa {
        display: var(--fa-display, inline-block) !important;
        height: 1em !important;
        overflow: visible !important;
        ${visualTypeFontSize ? `font-size: ${visualTypeFontSize}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element .cf-list-element .cf-items-divider:not(:last-child) {
        display: inline-block !important;
        ${elementDividerPresentWithoutLineHeight && variantDividerPresentWithoutLineHeight ? "margin-bottom: 10px !important; margin-top: 10px !important;" : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content {
        width: 100% !important;
        min-width: 0 !important;
        overflow-wrap: break-word !important;
        word-wrap: break-word !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content div,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h1,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h2,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h3,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h4,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content li {
        ${contentFontFamily ? `font-family: ${contentFontFamily}, sans-serif !important;` : ''}
        ${contentFontWeight ? `font-weight: ${contentFontWeight} !important;` : ''}
        ${contentFontSize ? `font-size: ${contentFontSize}px !important;` : ""}
        ${contentFontColor ? `color: ${contentFontColor} !important;` : ''}
        ${contentTextShadow ? `text-shadow: ${contentTextShadow} !important;` : ''}
        ${contentAlignment ? `text-align: ${contentAlignment} !important;` : 'text-align: left !important;'}
        ${contentLineHeight ? `line-height: ${contentLineHeight}px !important;` : ''}
      }

      /* Enable bullet points for nested lists within this specific element */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content ul {
        list-style-type: disc !important;
        padding-left: 20px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content ul li {
        list-style-type: disc !important;
        display: list-item !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content ul li::marker {
        color: ${contentFontColor || 'inherit'} !important;
      }

      /* Support for ordered lists */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content ol {
        list-style-type: decimal !important;
        padding-left: 20px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content ol li {
        list-style-type: decimal !important;
        display: list-item !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content ol li::marker {
        color: ${contentFontColor || 'inherit'} !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type-letter {
        ${visualTypeLetterColor ? `border: 2px solid ${visualTypeLetterColor} !important;` : ''}
        ${visualTypeLetterColor ? `background-color: ${visualTypeLetterColor}14 !important;` : ''}
        border-radius: 50% !important;
        ${visualFontSize ? `font-size: ${visualFontSize * 0.7}px !important;` : ""}
        width: ${visualFontSize * 1.2}px !important;
        height: ${visualFontSize * 1.2}px !important;
        line-height: ${visualFontSize * 1.05}px !important;
        font-family: Arial, sans-serif !important;
        display: block !important;
        text-align: center !important;
        margin-left: auto !important;
        margin-right: auto !important;
        box-sizing: border-box !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type-numbered {
        font-family: Arial, sans-serif !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-image-visual-type {
        line-height: initial !important;
        box-sizing: border-box !important;
        flex-shrink: 0 !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-image-visual-type img {
        ${visualTypeImageWidth ? `width: ${visualTypeImageWidth}px !important;` : ""}
        max-width: 100% !important;
      }
      `;

    let contentFontSizeMobile;
    if (options["content-font-size-mobile"]) {
      contentFontSizeMobile = options["content-font-size-mobile"];
    }

    let visualTypeFontSizeMobile;
    if (options["visual-type-font-size-mobile"]) {
      visualTypeFontSizeMobile = options["visual-type-font-size-mobile"];
    } else if (variant.options["list-visual-type-font-size-mobile"]) {
      visualTypeFontSizeMobile =
        variant.options["list-visual-type-font-size-mobile"];
    }

    let contentLineHeightMobile;
    if (options["content-font-line-height-mobile"]) {
      contentLineHeightMobile = options["content-font-line-height-mobile"];
    } else if (variant.options["list-content-font-line-height-mobile"]) {
      contentLineHeightMobile =
        variant.options["list-content-font-line-height-mobile"];
    }

    let visualTypeImageWidthMobile;
    if (element.options["visual-type-image-width-mobile"]) {
      visualTypeImageWidthMobile =
        element.options["visual-type-image-width-mobile"];
    } else if (variant.options["list-visual-type-image-width-mobile"]) {
      visualTypeImageWidthMobile =
        variant.options["list-visual-type-image-width-mobile"];
    } else if (contentFontSizeMobile) {
      visualTypeImageWidthMobile = contentFontSizeMobile * 2.5;
    } else {
      visualTypeImageWidthMobile = "134";
    }

    let visualTypeWidthMobile = "";
    let visualFontSizeMobile =
      visualTypeFontSizeMobile ||
      variant.options["list-visual-type-font-size-mobile"] ||
      visualFontSize;
    visualTypeWidthMobile = `${parseInt(visualFontSizeMobile) * 2.8}`;

    let listVisualTypeSpacingMobile =
      options["list-visual-type-spacing-mobile"] ||
      options["list-visual-type-spacing"] ||
      variant.options["list-visual-type-spacing-mobile"] ||
      variant.options["list-visual-type-spacing"] ||
      undefined;

    // prettier-ignore
    const mobileStyles =
      `/* mobile styles */
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} {
        ${contentLineHeightMobile ? `line-height: ${contentLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content div,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content p,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h1,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h2,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h3,
      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] .cf-list-element-item .cf-content h4 {
        ${contentFontSizeMobile ? `font-size: ${contentFontSizeMobile}px !important;` : ""}
        ${contentLineHeightMobile ? `line-height: ${contentLineHeightMobile}px !important;` : ''}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type {
        ${visualTypeFontSizeMobile ? `font-size: ${visualTypeFontSizeMobile}px !important;` : ''}
        ${listVisualTypeSpacingMobile ? `margin-right: ${listVisualTypeSpacingMobile}px !important;` : `width: ${visualTypeWidthMobile}px !important;` }
        flex-shrink: 0 !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type-letter {
        ${visualTypeFontSizeMobile ? `font-size: ${parseInt(visualTypeFontSizeMobile) * 0.6}px !important;` : ''}
        width: ${visualFontSizeMobile}px !important;
        height: ${visualFontSizeMobile}px !important;
        line-height: ${visualFontSizeMobile * 0.8}px !important;
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-image-visual-type img {
        ${visualTypeImageWidthMobile ? `width: ${visualTypeImageWidthMobile}px !important;` : ""}
      }

      #cta_${cta.id} .cf-element[data-element-id="${element.id}"] #list-item-${list_item.id} .cf-visual-type .svg-inline--fa {
        ${visualTypeFontSizeMobile ? `font-size: ${visualTypeFontSizeMobile * 0.7}px !important;` : ""}
      }
      `;

    if (builder !== true) {
      return desktopStyles + "@media (max-width: 599px) {" + mobileStyles + "}";
    } else {
      if (device == "desktop") {
        return desktopStyles;
      } else {
        return desktopStyles + mobileStyles;
      }
    }
};
